var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._v(" "+_vm._s(_vm.$t('사용자_목록'))+" "+_vm._s(_vm.$route.path)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }